module.exports = __webpack_public_path__ + "static/assets/29288c2bcf406a40892edd2d8d44f1a7.png";